import { ProviderType } from "../../../../../../../services/cloudchipr.api";
import { commonGroupings, specificGroupings } from "../constants/groupings";

export const getDefaultGroupings = (providers: ProviderType[]) => {
  const groupings = new Set(commonGroupings);
  const disabledGroupings: Record<string, ProviderType[]> = {};

  const provider = providers.at(0);
  if (providers.length === 1 && provider) {
    specificGroupings[provider].forEach((grouping) => {
      groupings.add(grouping);
    });
  } else {
    const arrOfGroupings = providers.map(
      (provider) => specificGroupings[provider],
    );

    providers.forEach((provider) => {
      specificGroupings[provider].forEach((grouping) => {
        const allProviderHasTheSameGroupings = arrOfGroupings.every(
          (providerGroupings) => providerGroupings?.includes(grouping),
        );

        if (allProviderHasTheSameGroupings) {
          groupings.add(grouping);
        } else if (grouping) {
          disabledGroupings[grouping] = disabledGroupings[grouping]
            ? [...disabledGroupings[grouping], provider]
            : [provider];
        }
      });
    });
  }

  return {
    disabledGroupings,
    groupingOptions: Array.from(groupings),
  };
};
